import {
  AccordianProps,
  AccordianTemplateProps,
  AccordianProductTypeTemplate,
  AccordianDefaultTemplate,
  useAccordianEffect,
} from '../../..';

export const AccordianPartial = (props: AccordianProps) => {
  const [state, handlers] = useAccordianEffect(props);

  const templateProps: AccordianTemplateProps = {
    slots: props.slots,
    id: props.id,
    region: props.region,
    isLoading: props.isLoading || false,
    ...state,
    ...handlers,
  };

  let template;
  switch (props.template) {
    case 'accordianProductType':
      template = AccordianProductTypeTemplate(templateProps);
      break;
    case 'accordianDefault':
    default:
      template = AccordianDefaultTemplate(templateProps);
      break;
  }

  return template;
};
